import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL;

// Try staff (admin/subadmin/superadmin) first, then orguser as fallback.
export const requestPasswordReset = async (email) => {
  try {
    const res = await axios.post(`${API_BASE_URL}/users/forgot-password`, { email });
    return res.data;
  } catch (err) {
    // If staff path fails (e.g., 404), try orguser endpoint
    try {
      const res = await axios.post(`${API_BASE_URL}/orguser/auth/forgot-password`, { email });
      return res.data;
    } catch (orgErr) {
      throw orgErr.response?.data || err.response?.data || { message: 'Password reset request failed' };
    }
  }
};

// Try staff reset first; if token is not for staff, fallback to orguser.
export const resetPassword = async (resetToken, newPassword) => {
  try {
    const res = await axios.post(`${API_BASE_URL}/users/reset-password`, {
      resetToken,
      newPassword,
    });
    return res.data;
  } catch (err) {
    try {
      const res = await axios.post(`${API_BASE_URL}/orguser/auth/reset-password`, {
        resetToken,
        newPassword,
      });
      return res.data;
    } catch (orgErr) {
      throw orgErr.response?.data || err.response?.data || { message: 'Password reset failed' };
    }
  }
};

export default {
  requestPasswordReset,
  resetPassword,
};